(function () {
  function initBundle(bundle) {
    if (bundle.dataset.bundleInit) return;
    bundle.dataset.bundleInit = '1';

    var max = parseInt(bundle.getAttribute('data-max'), 10) || 2;
    var list = bundle.querySelector('[data-bundle-list]');
    var template = bundle.querySelector('[data-bundle-row-template]');
    var addBtn = bundle.querySelector('[data-bundle-open]');
    var drawer = bundle.querySelector('[data-bundle-drawer]');
    var selected = [];

    // Flyt drawer til body, så den ligger øverst (over header)
    if (drawer && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bundle-no-scroll');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bundle-no-scroll');
    }

    function render() {
      // Fjern eksisterende ekstra-rækker
      list.querySelectorAll('[data-bundle-row]').forEach(function (r) { r.remove(); });
      selected.forEach(function (item, i) {
        var node = template.content.firstElementChild.cloneNode(true);
        node.querySelector('.bundle__num').textContent = i + 2;
        node.querySelector('.bundle__name').textContent = item.title;
        node.setAttribute('data-bundle-variant', item.id);
        node.querySelector('[data-bundle-remove]').addEventListener('click', function () {
          selected.splice(i, 1);
          render();
        });
        list.appendChild(node);
      });
      addBtn.style.display = selected.length >= max ? 'none' : '';
    }

    if (addBtn) addBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-bundle-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('[data-bundle-choose], .bundle__choose').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (selected.length >= max) return;
        selected.push({ id: btn.getAttribute('data-variant'), title: btn.getAttribute('data-title') });
        render();
        closeDrawer();
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Tilføj hele pakken til kurv
    var bbWrap = bundle.closest('[data-bb-id]') || bundle.parentNode;
    var form = bbWrap ? bbWrap.querySelector('product-form form') : null;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (selected.length === 0) return; // kun nuværende produkt → normal tilføjelse
        e.preventDefault();
        e.stopImmediatePropagation();

        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        var items = [{ id: idInput.value, quantity: 1 }];
        selected.forEach(function (s) { items.push({ id: s.id, quantity: 1 }); });

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var sections = cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.classList.add('loading');

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (cart && res.sections) {
              cart.renderContents(res);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (err) { console.error('Bundle add error:', err); })
          .finally(function () { if (submitBtn) submitBtn.classList.remove('loading'); });
      }, true); // capture: kør før product-form.js
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-bundle]').forEach(initBundle);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
